import React, { Component, PropTypes } from 'react';
import { Paper, FontIcon, LinearProgress, RaisedButton } from 'material-ui';
import { connect } from 'react-redux';
import R from 'ramda';
import injectSheet from 'react-jss';
import { checkLocAccess } from '../../../middleware/accessCheckHelperFns';
import Comment from './comment';
import CommentBox from '../generic-components/comment-box';
import { getHistoryFeeds } from '../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import {
  contractingAddFile,
  contractingCancelComment,
  contractingCommentInput,
  setContractingCommentBoxFocus,
  submitContractingComment,
} from '../../../stores/contracting/contract-activities-products/comment-actions';
import CommentsTitle from './comments-title';
import SendRCMessage from '../dummy-account/send-message';
import ResendContract from '../contract-activities-products/contract-container/dialogs/resend-or-update-dialog';

const styles = {
  container: {
    // backgroundColor: '#f0f0f0',
    // height: 'calc(100vh - 268px)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '32px',
  },
  containerSupplier: {
    // height: 'calc(100vh - 168px) !important',
  },
  workspaceBody: {
    height: '100%',
  },
  commentBox: {
    margin: '0 0 16px 11%',
  },
  ContractContentMessages: {
    // backgroundColor: 'white',
    // overflowY: 'scroll',
    // padding: '0 2px',
    // flex: '1 1 auto',
    // overflowX: 'hidden',
    // margin: '8px 4%',
    // marginLeft: '10%',
    width: '100%',
    height: '100%',
    position: 'relative',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0,
      },
    },
  },
  heatherTitle: {
    flex: '0 1 auto',
  },
  commentDisabledContainer: {
    border: `1px dashed #bfbfbf`,
    marginTop: '24px',
    padding: '16px',
    height: '80px',
  },
  commentDisabledText: {
    display: 'inline-block',
    marginLeft: '12px',
    width: '80%',
    position: 'relative',
    top: '4px',
  },
  actionBtnContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  dlBtn: {
    backgroundColor: '#e3f2fd',
  },
};

const propTypes = {
  contractId: PropTypes.string.isRequired,
  viewerCompanyId: PropTypes.string,
  className: PropTypes.string,
  classNameMessages: PropTypes.string,
  classNameCommentBox: PropTypes.string,
  messageArray: PropTypes.array,
  comment: PropTypes.func,
  commentBox: PropTypes.object,
  submitContractingComment: PropTypes.func,
  historyFeedId: PropTypes.string,
  companyType: PropTypes.string,
  commentDisabled: PropTypes.bool,
  addFileToContractInDB: PropTypes.func,
  getHistoryFeeds: PropTypes.func,
  isInMessaging: PropTypes.bool,
  partner: PropTypes.object,
  contentLoading: PropTypes.bool,
  readOnly: PropTypes.bool,
  contractingCommentInput: PropTypes.func,
  contractingAddFile: PropTypes.func,
  contractingCancelComment: PropTypes.func,
  setContractingCommentBoxFocus: PropTypes.func,
  classes: PropTypes.object,
  filesInContract: PropTypes.array,
  isWorkspace: PropTypes.bool,
  openRLSendMsg: PropTypes.func,
  openResendContractDialog: PropTypes.func,
  supplierEmails: PropTypes.array,
  templateFromDummy: PropTypes.bool,
};

class ContractCommentsAndActivities extends Component {
  constructor(props) {
    super(props);
    this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false,
    };
    this.state = Object.assign({
      page: 1,
      loading: false,
    }, this.defaultState);
  }
  componentWillMount() {
    this.props.getHistoryFeeds('contract', this.props.contractId);
  }
  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.onScroll, true);
    } else {
      window.attachEvent('onscroll', this.onScroll);
    }
    // comment below timer temporarily as we currently don't have that kind of traffic in history feed
    // if (!this.timer) this.timer = setInterval(this.timedUpdate, 3e3);
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener('scroll', this.onScroll, true);
    } else {
      window.detachEvent('onScroll', this.onScroll);
    }
    // comment below timer temporarily as we currently don't have that kind of traffic in history feed
    // clearInterval(this.timer);
  }
  onScroll = () => {
    if (this.state.page * 5 < this.props.messageArray.length && !this.state.loading) {
      const ele = document.getElementById('activities');
      if (ele) {
        const scrollEleBound = ele.getBoundingClientRect();
        if (scrollEleBound.bottom < window.innerHeight + 150) {
          this.setState({ loading: true });
          setTimeout(() => {
            this.setState({ page: this.state.page + 1, loading: false });
          }, 500);
        }
      }
    }
  };
  timedUpdate = () => {
    if (!localStorage.stopAutoReload && !this.props.contentLoading) this.props.getHistoryFeeds('contract', this.props.contractId);
  }
  handleComment = (input) => {
    this.setState({ currentComment: input });
  }
  submitComment = () => {
    this.setState({ disableSend: true }, () => {
      const { commentBox, contractId, historyFeedId } = this.props;
      const { attachedFiles } = commentBox;
      this.props.submitContractingComment({
        files: attachedFiles,
        contractId,
        comment: this.state.currentComment,
        historyFeedId,
      });
      this.setState({ currentComment: '', disableSend: false });
      this.clearInput();
    });
  }
  timer = null
  render() {
    const {
      messageArray,
      commentBox,
      companyType,
      commentDisabled,
      contractId,
      viewerCompanyId,
      isInMessaging,
      partner,
      filesInContract,
      readOnly,
      className,
      classes,
      isWorkspace,
      openRLSendMsg,
      supplierEmails,
      templateFromDummy,
      ...rest
    } = this.props;
    // if (R.isEmpty(this.props.messageArray)) return <div/>;
    const onClickSendMsg = who => () => openRLSendMsg({
      who,
      emails: who === 'DL' ? ['dl@tourconnect.com'] : supplierEmails,
    });
    const { focused } = commentBox;
    const recipientName = partner ? partner.name : 'Unknown';
    return (
    <div
      className={className || (`${classes.container}${(companyType === 'Supplier' ? ` ${this.props.classes.containerSupplier}` : '') }`)}
    >
      {
        isInMessaging ? (
          <CommentsTitle className={this.props.classes.heatherTitle} recipientName={recipientName} linkAction={() => this.context.router.push(`/contracting/contract/${contractId}/details`)} />
        ) : <div/>
      }
      {
        (() => {
          if (commentDisabled || readOnly) {
            return (
              <div className={classes.commentDisabledContainer}>
                <FontIcon className="tc-icon-question_answer" color="#bfbfbf" style={{ top: '6px', float: 'left' }} />
                <div className={classes.commentDisabledText}>
                  {'Message box is disabled because you do not have access.'}
                </div>
              </div>
            );
          }
          if (isWorkspace && companyType === 'Contractor') {
            return (
              <div className={classes.commentBox}>
                <div className={classes.actionBtnContainer}>
                  {/* <RaisedButton
                    backgroundColor={styles.dlBtn.backgroundColor}
                    labelStyle={{ textTransform: 'none' }}
                    label="Send Message to TourConnect Data Team"
                    onClick={onClickSendMsg('DL')}
                  /> */}
                  <RaisedButton
                    label="Send Message to Partner"
                    onClick={onClickSendMsg('Supplier')}
                  />
                </div>
              </div>
            );
          }
          if (!isWorkspace && companyType === 'Contractor' && templateFromDummy) {
            return (
              <div className={classes.commentBox}>
                {/* <div className={classes.actionBtnContainer}>
                  <RaisedButton
                    backgroundColor={styles.dlBtn.backgroundColor}
                    labelStyle={{ textTransform: 'none' }}
                    label="Send Message to TourConnect Data Team"
                    onClick={onClickSendMsg('DL')}
                  />
                </div> */}
              </div>
            );
          }
          return (
            <Paper className={classes.commentBox}>
              <CommentBox
                comment={this.state.currentComment}
                handleInput={this.handleComment}
                attachFile={this.props.contractingAddFile}
                setFocus={this.props.setContractingCommentBoxFocus}
                submitComment={this.submitComment}
                cancelComment={() => {
                  this.props.contractingCancelComment();
                  this.setState({ currentComment: '' });
                  this.clearInput();
                }}
                setClear={clear => this.clearInput = clear}
                contractId={contractId}
                focused={focused}
                disableSend={this.state.disableSend}
                {...rest}
              />
            </Paper>
          );
        })()
      }
      <div
        className={classes.ContractContentMessages}
        id="activities"
      >
        {messageArray.slice(0, this.state.page * 5).map((message, key) => (
          <Comment
            key={key}
            msgObject={message}
            filesInContract={filesInContract}
            viewerCompanyId={viewerCompanyId}
            companyType={companyType}
            isInMessaging={isInMessaging}
            contractIdOfThread={contractId}
          />
        ))}
        {
          this.state.loading && (
            <LinearProgress/>
          )
        }
        {
          this.state.page * 5 >= messageArray.length && (
            <p style={{ textAlign: 'center' }}>
              <b>Yay! You have seen it all!</b>
            </p>
          )
        }
      </div>
      <SendRCMessage inActivityFeed/>
      <ResendContract/>
    </div>
    );
  }
}

ContractCommentsAndActivities.propTypes = propTypes;

ContractCommentsAndActivities.defaultProps = {
  messageArray: [],
};

const mapStateToProps = state => {
  const { contracting, user } = state;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const readOnly = !checkLocAccess(state, leftNav.locationId, 'contracting', 'write');
  const contactsOfThePartner = R.path(['partners', 0, 'contacts'], leftNav);
  return ({
    readOnly,
    commentBox: contracting.commentBox,
    contentLoading: contracting.contractActivitiesProducts.get('contentLoading'),
    templateFromDummy: leftNav.templateFromDummy,
    ...contracting.contractActivitiesProducts.get('activities').toJS(),
    isWorkspace: !leftNav.locationId,
    viewerCompanyId: user.getIn(['company', 'companyId']),
    companyType: user.getIn(['user', 'type']),
    supplierEmails: contactsOfThePartner ? contactsOfThePartner.map(o => o.email) : state.dummyAcct.inCR.supplierEmails,
  });
};
ContractCommentsAndActivities.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, {
  getHistoryFeeds,
  contractingCommentInput,
  contractingAddFile,
  contractingCancelComment,
  setContractingCommentBoxFocus,
  submitContractingComment,
  openRLSendMsg: payload => ({ type: '{rl-send-message}OPEN_SEND_MESSAGE', payload }),
  openResendContractDialog: payload => ({ type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload }),
})(injectSheet(styles)(ContractCommentsAndActivities));



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/comments.jsx